
<template>
  <el-dialog :title="title" :visible.sync="visible" v-loading="loading" :close-on-click-modal="false" width="50%">
    <el-form ref="addForm" :model="addForm" :rules="addFormRule" inline label-width="160px">
      <el-form-item label="商品名称" prop="goodsName">
        <el-input v-model.trim="addForm.goodsName" maxlength="128" clearable />
      </el-form-item>
      <el-form-item label="规格型号" prop="ruleType">
        <el-input v-model.trim="addForm.ruleType" maxlength="128" clearable />
      </el-form-item>
      <el-form-item label="数量" prop="goodsNum">
        <el-input v-model.trim="addForm.goodsNum" maxlength="18" @blur="check_int0($event, 'addForm', 'goodsNum')" clearable />
      </el-form-item>
      <el-form-item label="单价范围(元)" prop="hightPrice">
        <el-input style="width: 125px" v-model.trim="addForm.lowPrice" @blur="check_amount($event, 'addForm', 'lowPrice')" maxlength="18" clearable>
          <span slot="suffix">元</span>
        </el-input>
        ~
        <el-input style="width: 125px" v-model.trim="addForm.hightPrice" @blur="check_amount($event, 'addForm', 'hightPrice')" maxlength="18" clearable>
          <span slot="suffix">元</span>
        </el-input>
      </el-form-item>
      <el-form-item label="原产国(地区)" prop="countryOfOrigin">
        <el-input v-model.trim="addForm.countryOfOrigin" maxlength="128" clearable />
      </el-form-item>
      <el-form-item label="币制">
        <el-input v-model.trim="addForm.currency" maxlength="128" disabled clearable />
      </el-form-item>
      <el-form-item label="联系人电子邮箱" prop="email">
        <el-input v-model.trim="addForm.email" maxlength="128" clearable />
      </el-form-item>
      <el-form-item label="商品销售网址/店铺" prop="goodsNetWork">
        <el-input v-model.trim="addForm.goodsNetWork" maxlength="128" clearable />
      </el-form-item>
      <el-form-item label="加入来源">
        <el-input value="商户上报" maxlength="32" disabled clearable />
      </el-form-item>
      <el-form-item label="手机号" prop="phone">
        <el-input v-model.trim="addForm.phone" maxlength="32" clearable />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button v-if="type === 'add' || type === 'update'" type="primary" @click.native="submit" :loading="submitLoading">提交</el-button>
      <el-button @click.native="visible = false">取消</el-button>
      <!-- <el-button @click.native="printAll">打印值</el-button> -->
    </div>
  </el-dialog>
</template>
<script>
import { VDATA } from '@/utils/saas/validate'
import { setNull, parseAmtF2YABS } from '@/utils/common' // 工具类
import { insertGoods, updateGoods } from '@/api/crossborder/collection/abroadCollection'
export default {
  data() {
    return {
      title: '添加',
      type: 'add', // add-新增 update-修改
      visible: false,
      loading: false,
      submitLoading: false,
      addForm: {
        merNo: this.$store.getters.merNo,
        merName: this.$store.getters.merName,
        operator: this.$store.getters.merName,
        goodsOrderNo: null,
        goodsName: null,
        ruleType: null,
        goodsNum: null,
        lowPrice: null,
        hightPrice: null,
        countryOfOrigin: null,
        currency: '人民币',
        email: null,
        goodsNetWork: null,
        addSource: '01',
        phone: null,
        goodsStatus: '02',
        checkStatus: '01',
        platformType: '02',
      },

      addFormRule: {
        goodsName: [{ required: true, message: '请填写商品名称', trigger: 'blur' }],
        ruleType: [{ required: true, message: '请填写规格型号', trigger: 'blur' }],
        goodsNum: [{ required: true, message: '请填写商品数量', trigger: 'blur' }],
        hightPrice: [
          { required: true, message: '请填写价格', trigger: 'blur' },
          { validator: this.validateAmount, trigger: 'blur' },
        ],
        countryOfOrigin: [{ required: true, message: '请填写原产国(地区)', trigger: 'blur' }],
        email: [
          { required: false, message: '请填写联系人邮箱', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value) {
                const vdt = VDATA(value, {
                  email: {
                    msg: '请填写正确格式的交易email',
                  },
                })
                if (!vdt.result) {
                  callback(new Error('请填写正确格式的交易email'))
                } else {
                  callback()
                }
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
        goodsNetWork: [{ required: true, message: '请选择商品销售网址/店铺', trigger: 'blur' }],
        phone: [
          { required: false, message: '请填写手机号', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              console.log('rule', rule)
              console.log('value', value)
              if (value === '' || value === null) {
                callback()
                return
              }
              const vdt = VDATA(value, {
                elevenphone: {
                  msg: '请输入正确的手机号格式',
                },
              })
              if (!vdt.result) {
                callback(new Error(vdt.msg))
              } else {
                callback()
              }
            },
            trigger: 'blur',
          },
        ],
      },
    }
  },

  methods: {
    // 数量只能为正整数，包含0
    check_int0(event, mainName, propertyName) {
      let res = parseFloat(event.target.value.replace(/[^\d]/g, ''))
      // console.log('res-------------', res)
      this[mainName][propertyName] = res === 0 ? '0' : res ? res : ''
    },

    check_amount(event, mainName, propertyName) {
      // 金额只能为正数，不能为负数
      // 这里直接将输入的字符串转换成数字的字符串
      // let res = parseFloat(event.target.value.replace(/[^\d.]/g, '')) || ''
      this[mainName][propertyName] = parseFloat(event.target.value.replace(/[^\d.]/g, '')) || ''
    },
    /**
     * 检查是否为银行号码
     *
     */
    check_banknum(event, propertyName) {
      let value = event.target.value.replace(/[^\w]/g, '')
      if (value.length > 25) {
        value = value.slice(0, 24)
      }
      this.addForm[propertyName] = value
    },

    validateAmount(rule, value, callback) {
      if(!this.addForm.lowPrice || !this.addForm.hightPrice){
        callback(new Error('请填写金额'))
      } else if (this.addForm.lowPrice && this.addForm.hightPrice && parseFloat(this.addForm.hightPrice) < parseFloat(this.addForm.lowPrice)) {
        callback(new Error('最大金额不能小于最小金额'))
      } else {
        callback()
      }
    },

    open(type, row) {
      this.type = type
      this.visible = true

      if (type === 'add') {
        this.title = '添加'
        this.addForm = {
          merNo: this.$store.getters.merNo,
          merName: this.$store.getters.merName,
          operator: this.$store.getters.merName,
          goodsOrderNo: null,
          goodsName: null,
          ruleType: null,
          goodsNum: null,
          lowPrice: null,
          hightPrice: null,
          countryOfOrigin: null,
          currency: '人民币',
          email: null,
          goodsNetWork: null,
          addSource: '01',
          phone: null,
          goodsStatus: '02',
          checkStatus: '01',
          platformType: '02',
        }
      } else if (type === 'update') {
        this.title = '修改'
        this.addForm.merNo = this.$store.getters.merNo
        this.addForm.merName = this.$store.getters.merName
        this.addForm.operator = this.$store.getters.merName
        this.addForm.goodsOrderNo = row.goodsOrderNo
        this.addForm.goodsName = row.goodsName
        this.addForm.ruleType = row.ruleType
        this.addForm.goodsNum = row.goodsNum
        this.addForm.lowPrice = row.lowPrice ? parseAmtF2YABS(row.lowPrice) : null
        this.addForm.hightPrice = row.hightPrice ? parseAmtF2YABS(row.hightPrice) : null
        this.addForm.countryOfOrigin = row.countryOfOrigin
        this.addForm.email = row.email
        this.addForm.goodsNetWork = row.goodsNetWork
        this.addForm.phone = row.phone
        this.addForm.goodsStatus = row.goodsStatus
        this.addForm.checkStatus = row.checkStatus
      }
      this.$nextTick(() => {
        this.$refs.addForm.clearValidate()
      })
    },

    close() {
      this.visible = false
    },

    submit() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          const param = setNull({
            ...this.addForm,
          })
          if (this.type === 'add') {
            this.submitLoading = true
            insertGoods(param)
              .then((res) => {
                this.submitLoading = false

                // console.log(res)
                this.$message.success('成功')
                this.$emit('success') // 发送查询事件，让父组件查询相应列表
                this.close()
              })
              .catch((error) => {
                this.submitLoading = false
                console.log('添加商品名录失败', error)
              })
          }

          if (this.type === 'update') {
            this.submitLoading = true
            updateGoods(param)
              .then((res) => {
                // console.log(res)
                this.submitLoading = false
                this.$message.success('成功')
                this.$emit('success')
                this.close()
              })
              .catch((error) => {
                this.submitLoading = false
                console.log('更新商品名录失败', error)
              })
          }
        }
      })
    },

    printAll() {
      console.log('this.addForm', this.addForm)
    },
  },
}
</script>
<style scoped>
::v-deep .el-form-item__content {
  width: 270px;
}
::v-deep .el-select {
  width: 100%;
}
</style>